import ViewDetailsComponent from './../../../../shared/components/viewdetails';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant'

export default {
  name: 'RateTemplateView',
  components: {
    ViewDetailsComponent,
    VueElementLoading
  },
  props: [],
  data: function() {
    return {
      ratebasis:null,
      insurancechargetype:null,
      insuranceapplicablecharge:null,
      fovtype:null,
      selectedEditRow:null,
      weightDimensionData: [],
      frightChargesData: [],
      baseRateData: [],
      insuranceChargesData: [],
      FOVChargeType:null,
      accessorialChargesData: [],
      minimumChargesData: [],
      isLoading: false,
      freightwttype: null,
      uom: "",
      SYMBOL_CONFIG: {
        [CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
        [CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
        [CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
        [CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
      },
      matrixHeaderArray1: [],
      matrixTableDataArray1: [],
      matrixVerticalHeaderArray1: [],
      matrixHeaderArray2: [],
      matrixTableDataArray2: [],
      matrixVerticalHeaderArray2: [],
      matrixLabel1: {
        horizontal: "Physical Weight (kg)",
        verticle: "Distance (km)"
      },
      matrixLabel2: {
        horizontal: "Physical Weight (kg)",
        verticle: "Distance (km)"
      },
      matrixTableDataZoneArray: [],
      matrixHeaderCityArray: [],
      matrixHeaderZoneArray: [],
      matrixTableDataCityArray: [],
      matrixSlabHeaderArray: [],
      matrixTableDataSlabCityArray: [],
      matrixTableDataSlabZoneArray: [],
      accordianTypeArr: ['weightDimension', 'baseRate','minimumCharges','frightCharges', 'insuranceCharges', 'accessorialCharges'],
      opened: [],
      accordianArr: [],
      expanded: false,
      selectedEditRowDataEdit:'',
      odatable1:[],
      odatable2:[],
      odatable3:[],
      odatable4:[],
      pickupodatable1:[],
      pickupodatable2:[],
      pickupodatable3:[],
      pickupodatable4:[],
      downloadData:{},
      tarifftype:'',
      volweightlist: [
        {text:"4500 ", value:"4500"},
        {text:"20000 ", value:"20000"},
        {text:"Other ", value:"other"},
      ],

      applicableWeightRoundlist: [{text:"Up", value:"up"},
      {text:"Down", value:"down"}],

      applicableMaxMinList: [{text:"Min", value:"min"},
      {text:"Max", value:"max"}],

      ApplicableWeightList: [{text:"Physical Weight", value:"physicalweight"},
      {text:"Volumetric Weight", value:"volumetricweight"},
      {text:"Max (Physical Weight or Volumetric Weight)", value:"maxofphysicalorvolumetricweight"}],

      ApplicableWeightList2: [{text:"Physical Weight", value:"physicalweight"},
      {text:"Volumetric Weight", value:"volumetricweight"},
      {text:"Minimum Chargeable Weight", value:"chargeableweight"}],

      billMaxMinlist: [{text:"Min", value:"min"},
      {text:"Max", value:"max"}],

      billWeightList: [{text:"Minimum Chargeable Weight", value:"chargeableweight"},
      {text:"Applicable Weight", value:"applicableweight"}],
      servicetype : null
    }
  },
  computed: {},
  mounted() {},
  methods: {
    setValues(selectedEditRow){
      if(selectedEditRow.uom && selectedEditRow.uom=="cm"){
        this.uom = 'Centimeter';
      }else if(selectedEditRow.uom && selectedEditRow.uom=="in"){
        this.uom = 'Inch';
      }

      this.selectedEditRow = selectedEditRow;
      this.weightDimensionData=[];
      this.frightChargesData=[];
      this.baseRateData=[];
      this.insuranceChargesData=[];
      this.accessorialChargesData=[];
      this.minimumChargesData=[];
      this.getWeightDimensionData(this.selectedEditRow.id);
    },
    dataLoad(type) {
      // this.opened = this.accordianArr
      this.expanded = false;
      if (this.opened.indexOf(type) == -1) {
        this.accordianArr = []
        this.opened = []
        this.opened.push(type)
        this.accordianArr = this.opened
        if (type == "weightDimension") {
          //this.getWeightDimensionData(this.selectedEditRow.id);
        }
        if (type == "baseRate") {
          this.getBaseRateData(this.selectedEditRow.id);
        }
        if (type == "frightCharges") {
          //this.getFrightChargesData(this.selectedEditRow.id)
        }
        if (type == "insuranceCharges") {
          this.getInsuranceChargesData(this.selectedEditRow.id)
        }
        if (type == "accessorialCharges") {
          this.getAccessorialChargesData(this.selectedEditRow.id)
        }
        if (type == "minimumCharges") {
          this.getAccessorialChargesData(this.selectedEditRow.id)
        }
      } else {
        this.accordianArr = []
        this.opened = []
      }
    },

    LoadAllAccordianData() {
      //this.getWeightDimensionData(this.selectedEditRow.id);
      this.getBaseRateData(this.selectedEditRow.id);
      //this.getFrightChargesData(this.selectedEditRow.id)
      this.getInsuranceChargesData(this.selectedEditRow.id)
      this.getAccessorialChargesData(this.selectedEditRow.id)
    },

    async getWeightDimensionData(id) {
      if(this.weightDimensionData.length >0){
        return;
      }
      this.isLoading = true;
      let payload = {}
      let result

      if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
        payload.ratetemplateid = id
        result = await MasterService.rateTemplateMasterDetails(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
        payload.contractid = this.selectedEditRow.id
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.contractMasterRateDetails(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        payload.contractid = this.selectedEditRow.id
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.clientContractMasterRateDetails(payload);
      }
      let data = result.data.data.rows[0];
      this.ratebasis = (data.ratebasis == 1)?"Weight (kg)":(data.ratebasis == 2)?"Quantity (Number of boxes)":"",
      this.freightwttype = data.ratebasis == 1 ? 'Billable Weight' : ' Number of boxes'
      this.FOVChargeType = data.fovtype == 1 ? 'Flat Charges Per Shipment' : null
      this.insurancechargetype = data.insurancechargetype;
      this.fovtype = data.fovtype;
      this.insuranceapplicablecharge = data.insuranceapplicablecharge;
      this.frightChargesData = [{
        type: "detail",
        key: "Freight Charges",
        value: "Base Rate x "+this.freightwttype
      }
      ]
      this.servicetype = data.servicetype;
      let applicableWeight1;
      let applicableWeight2;
      let applicatbleRound;
      let applicableMinMax;

        applicatbleRound = data.billwt && data.billwt.round && this.applicableWeightRoundlist.find(o => o.value == (data.billwt.round)).text;

        applicableMinMax = data.applicablewt && data.applicablewt.maxMin && this.applicableMaxMinList.find(o => o.value == data.applicablewt.maxMin).text;;

        applicableWeight1 = data.applicablewt && data.applicablewt.weight1 && this.ApplicableWeightList.find(o => o.value == ( data.applicablewt.weight1)).text;;

        applicableWeight2 = data.applicablewt && data.applicablewt.weight2 && this.ApplicableWeightList2.find(o => o.value == (data.applicablewt.weight2)).text;;


        let billMaxMin;
        let billWeight1;
        let billWeight2;

      //  billMaxMin = data.billwt && data.billwt.billMaxMim && this.billMaxMinlist.find(o => o.value == (data.billwt.billMaxMim)).text;

        billWeight1 = data.billwt && data.billwt.billWeight1 && this.billWeightList.find(o => o.value == (data.billwt.billWeight1)).text;;

        billWeight2 = data.billwt && data.billwt.billWeight2 && this.billWeightList.find(o => o.value == (data.billwt.billWeight2)).text;;

      let voluMetricWtDivisor = data.volumetricwtdivisor;


      let applicableWeight;
      if(applicableWeight1!="" && applicableWeight2!=""){
        applicableWeight = applicableWeight1 + ' OR '+ applicableWeight2;
      }else if(applicableWeight1!=""){
        applicableWeight = applicableWeight1;
      }else{
        applicableWeight = applicableWeight2;
      }

      let billWeight =  billWeight1;;
      // if(billWeight1!="" && billWeight2!=""){
      //   billWeight = billWeight1 + ' OR '+ billWeight2;
      // }else if(billWeight1!=""){
      //   billWeight = billWeight1;
      // }else{
      //   billWeight = billWeight2;
      // }

      if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        if(data.ratebasis==1){
          this.weightDimensionData = [
            {
              type: "label",
              key: "CFT Divisor",
              value: data.volumetricwtdivisor
            },
            {
              type: "label",
              key: "Preffered UOM for Dimensions",
              value: this.uom
            },
            {
              type: "label",
              key: "Agreed Weight per CFT (kg)",
              value: data.agreedwtcft
            },
            {
              type: "label",
              key: "Minimum Chargeable Weight (kg)",
              value: data.minimumchargeablewt
            },
            {
              type: "heading",
              key: "Applicable Weight",
              value: [
                {
                  type: "label",
                  key: "Max/Min",
                  value: applicableMinMax
                },
                {
                  type: "detail",
                  key: "Weight: ",
                  value: applicableWeight
                }
              ]
            },
            {
              type: "heading",
              key: "Bill Weight",
              value: [{
                  type: "label",
                  key: "Rounding",
                  value: applicatbleRound
                },
                {
                  type: "label",
                  key: "Rounding Factor (kg)",
                  value: data.billwt && data.billwt.roundFactor
                },
                {
                  type: "detail",
                  key: "Weight: ",
                  value: billWeight
                }
              ]
            },
          ]
        }
        if(data.ratebasis == 2){
          this.weightDimensionData = [
            {
              type: "label",
              key: "CFT Divisor",
              value: data.volumetricwtdivisor
            },
            {
              type: "label",
              key: "Preffered UOM for Dimensions",
              value: this.uom
            },
            {
              type: "label",
              key: "Agreed Weight per CFT (kg)",
              value: data.agreedwtcft
            },
            {
              type: "label",
              key: "Minimum Boxes",
              value: data.minimumboxes
            },
          ]
        }
      }else{
        this.weightDimensionData = [
          {
            type: "label",
            key: "Agreed Weight per CFT (kg)",
            value: data.agreedwtcft
          }]
          if(data.ratebasis == 2){
            this.weightDimensionData.push({
            type: "label",
            key: "Minimum Boxes",
            value: data.minimumboxes
          })
        }
        if(data.ratebasis == 1){
          this.weightDimensionData.push({
          type: "label",
          key: "Minimum Chargeable Weight (kg)",
          value: data.minimumchargeablewt
        },
        {
          type: "heading",
          key: "Applicable Weight",
          value: [
            {
              type: "label",
              key: "Max/Min",
              value: applicableMinMax
            },
            {
              type: "detail",
              key: "Weight: ",
              value: applicableWeight
            }
          ]
        },
        {
          type: "heading",
          key: "Bill Weight",
          value: [{
              type: "label",
              key: "Rounding",
              value: applicatbleRound
            },
            {
              type: "label",
              key: "Rounding Factor (kg)",
              value: data.billwt && data.billwt.roundFactor
            },
            {
              type: "detail",
              key: "Weight: ",
              value: billWeight
            }
          ]
        })
      }
    }
      this.isLoading = false;
    },
    async getFrightChargesData(id) {
      // this.isLoading = true;
      // let payload = {}
      // let data;
      // if (!this.freightwttype) {
      //   let result
      //   // let result = await MasterService.rateTemplateMasterDetails(payload);
      //   if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
      //     payload.ratetemplateid = id
      //     result = await MasterService.rateTemplateMasterDetails(payload);
      //   } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
      //     payload.contractid = this.selectedEditRow.id
      //     payload.ratetemplateid = this.selectedEditRow.ratetemplateid
      //     result = await MasterService.contractMasterRateDetails(payload);
      //   } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
      //     payload.contractid = this.selectedEditRow.id
      //     payload.ratetemplateid = this.selectedEditRow.ratetemplateid
      //     result = await MasterService.clientContractMasterRateDetails(payload);
      //   }

      //   data = result.data.data.rows[0]
      //   this.freightwttype = data.freightwttype == 1 ? 'Billable Weight' : null
      // }

      // this.frightChargesData = [{
      //     type: "label",
      //     key: "Weight",
      //     value: this.freightwttype
      //   }
      // ]
      // this.isLoading = false;

    },
    async getBaseRateData(id) {

      //this.baseRateData = []
      if(this.baseRateData.length>0){
        return
      }
      this.isLoading = true;
      let matrixLabel = {
        horizontal: "Pickup From",
        verticle: "Deliver To"
      }
      let payload = {}
      let result
      if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
        payload.ratetemplateid = id
        result = await MasterService.getBasicBaserate(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.getContractBasicBaserate(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.getClientContractBasicBaserate(payload);
      }
      this.downloadData = {
        ComponentName : this.selectedEditRow.ComponentName,
        ratetemplateid : payload.ratetemplateid,
        servicetype : this.servicetype,
        isexceptionalcity : false
      }
      if (result.data.data && result.data.data[0] && result.data.data[0].slabid) {
        this.matrixSlabHeaderArray = []
        if (result.data.data[0].isexceptionalcity) {
          result.data.data.sort((a, b) => a.slabnumber - b.slabnumber).forEach((el) => {
            if (el.servicetype == 2) {
              let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
              this.matrixSlabHeaderArray.push({
              id: el.slabnumber,
              name: name
              });
            }
          });
        }else{
              result.data.data.sort((a, b) => a.slabnumber - b.slabnumber).forEach((el) => {
              let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`
              this.matrixSlabHeaderArray.push({
              id: el.slabnumber,
              name: name
              });
            });
        } 
        this.baseRateData.push({
          type: "label",
          key: "Tariff Type",
          value: "Slab"
        },
        {
          type: "label",
          key: "Slab Type",
          value: (result.data.data[0].slabtype == 1)?"Weight":(result.data.data[0].slabtype == 2)?"Quantity":"",
        },
        {
          type: "label",
          key: "Slab Charge Type",
          value: (result.data.data[0].baserateslabchargetype == 1)?"Incremental":(result.data.data[0].baserateslabchargetype == 2)?"Absolute":"",
        })

        this.matrixSlabHeaderArray.forEach((obj, index) => {
          //this.downloadData.slabsequence = index + 1
          let value = [{
            type: "excelDownload",
            key: "Tariff Type",
            value: this.downloadData,
            index: index
          }]
          
          if (result.data.data[0].isexceptionalcity) {
            let downloadpayload = {
              ComponentName : this.selectedEditRow.ComponentName,
              ratetemplateid : payload.ratetemplateid,
              servicetype : 1,
              isexceptionalcity : true
            }
            value.push({
              type: "excelDownload",
              key: "Tariff Type",
              value: downloadpayload,
              index: index
            })
          }
          this.baseRateData.push({
            type: "heading",
            key: "Break " + obj.id + " (Billable weight (Kg): " + obj.name + ")",
            value: value
          })
        })

      } else if(result.data.data[0]) {
       // await this.getSelectedTemplateInfo(result.data.data[0].serviceareaid, result);
       this.downloadData.slabsequence = 0;
        this.baseRateData.push({
          type: "label",
          key: "Tariff Type",
          value: "Flat"
        }, {
          type: "excelDownload",
          key: "Tariff Type",
          value: this.downloadData
        })
        if (result.data.data[0].isexceptionalcity) {
          let downloadpayload = {
            ComponentName : this.selectedEditRow.ComponentName,
            ratetemplateid : payload.ratetemplateid,
            servicetype : 1,
            isexceptionalcity : true
          }
          this.baseRateData.push({
            type: "excelDownload",
            key: "Tariff Type1",
            value: downloadpayload
          })
        }
      }
      this.isLoading = false;
    },

    async getInsuranceChargesData(id) {
      //this.insuranceChargesData = null
      if(this.insuranceChargesData.length>0){
        return;
      }
      this.isLoading = true;
      let payload = {}
      let data
      let result

      if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
        payload.ratetemplateid = id
        result = await MasterService.getInsuranceRateList(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.getContractInsuranceRateList(payload);
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        result = await MasterService.getClientContractInsuranceRateList(payload);
      }
      data = result.data.data
      if(this.insuranceapplicablecharge==0){
        this.insuranceapplicablecharge="None";
      }
      if(this.insuranceapplicablecharge==1){
        this.insuranceapplicablecharge="FOV";
      }
      if(this.insuranceapplicablecharge==2){
        this.insuranceapplicablecharge="ROV";
      }
      if(this.insuranceapplicablecharge=="FOV"){
        if (data[0] && data[0].insurancechargetype == 1) {
          this.insuranceChargesData = [{
            type: "label",
            key: "Applicable charge",
            value: this.insuranceapplicablecharge
          },{
            type: "detail",
            key: "FOV Charge Type",
            value: "Invoice Value x FOV%"
          }]
          if (this.fovtype == 1) {
            this.insuranceChargesData.push({
              type: "heading",
              key: "FOV % Type",
              value: [{
                type: "label",
                key: "FOV Type",
                value: "Flat Rate"
              }, {
                type: "label",
                key: "FOV Rate (%)",
                value: data[0] && data[0].fovvalue
              }]
            })

          } else if(this.fovtype == 2) {

            let tableData = []
            data.map(obj => {
              tableData.push({
                "From": obj.fromvalue,
                "To": obj.tovalue,
                "FOV%": obj.fovvalue
              })
            })
            this.insuranceChargesData.push({
              type: "heading",
              key: "FOV % Type",
              value: [{
                type: "label",
                key: "FOV Type",
                value: "Slab Based"
              }, {
                type: "table",
                key: ["From", "To", "FOV%"],
                value: tableData
              }]
            })
          }
          this.insuranceChargesData.push({
            type: "heading",
            key: "Limits (FOV Charges) (INR)",
            value: [{
              type: "label",
              key: "MIN",
              value: data[0].minfovvalue
            }, {
              type: "label",
              key: "MAX",
              value: data[0].maxfovvalue
            }]
          })
        } else {
          this.insuranceChargesData = [{

            type: "label",
            key: "Applicable charge",
            value: this.insuranceapplicablecharge
          },{

            type: "label",
            key: "FOV Charge Per Shipment",
            value: data[0] && data[0].fovvalue
          }]
        }
      }else if(this.insuranceapplicablecharge=="ROV"){
        if (data[0] && data[0].insurancechargetype == 1) {
          this.insuranceChargesData = [{
            type: "label",
            key: "Applicable charge",
            value: this.insuranceapplicablecharge
          },{
            type: "detail",
            key: "ROV Charge Type",
            value: "Invoice Value x ROV%"
          }]
          if (this.fovtype == 1) {
            this.insuranceChargesData.push({
              type: "heading",
              key: "ROV % Type",
              value: [{
                type: "label",
                key: "ROV Type",
                value: "Flat Rate"
              }, {
                type: "label",
                key: "ROV Rate (%)",
                value: data[0] && data[0].fovvalue
              }]
            })

          } else if(this.fovtype == 2) {

            let tableData = []
            data.map(obj => {
              tableData.push({
                "From": obj.fromvalue,
                "To": obj.tovalue,
                "ROV%": obj.fovvalue
              })
            })
            this.insuranceChargesData.push({
              type: "heading",
              key: "ROV % Type",
              value: [{
                type: "label",
                key: "ROV Type",
                value: "Slab Based"
              }, {
                type: "table",
                key: ["From", "To", "ROV%"],
                value: tableData
              }]
            })
          }
          this.insuranceChargesData.push({
            type: "heading",
            key: "Limits (ROV Charges) (INR)",
            value: [{
              type: "label",
              key: "MIN",
              value: data[0].minfovvalue
            }, {
              type: "label",
              key: "MAX",
              value: data[0].maxfovvalue
            }]
          })
        } else {
          this.insuranceChargesData = [{

            type: "label",
            key: "Applicable charge",
            value: this.insuranceapplicablecharge
          },{

            type: "label",
            key: "ROV Charge Per Shipment",
            value: data[0] && data[0].fovvalue
          }]
        }
      }
      else{
        {
          this.insuranceChargesData = [{

            type: "label",
            key: "Applicable charge",
            value: this.insuranceapplicablecharge
          }]
        }
      }
      this.isLoading = false;
    },
    async getAccessorialChargesData(id) {
      //this.accessorialChargesData = null
      if(this.accessorialChargesData.length >0){
        return;
      }
      this.isLoading = true;
      let payload = {}
      let data;
      let deliveryRate
      let overWeightCharge
      let tableHeader = ["From", "To", "Cost per Docket"];
      let odaTableHeader = ["Slab Break", "Rate Per Basis"];
      let result
      let result2
      let result3
      let responseArr

      if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
        payload.ratetemplateid = id
        result =  MasterService.rateTemplateMasterDetails(payload);
        result2 =  MasterService.getVehicleDeliveryDetails(payload);
        result3 =  MasterService.getOverWtChargeDetails(payload);
        responseArr = await Promise.all([result, result2, result3])
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
        payload.contractid = this.selectedEditRow.id
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        let inputPayload = {
          ratetemplateid: this.selectedEditRow.ratetemplateid
        }
        result =  MasterService.contractMasterRateDetails(payload);
        result2 =  MasterService.getContractVehicleDeliveryRateList(inputPayload);
        result3 =  MasterService.getContractMasterOverWeightChargeList(inputPayload);
        responseArr = await Promise.all([result, result2, result3])
      } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        payload.contractid = this.selectedEditRow.id
        payload.ratetemplateid = this.selectedEditRow.ratetemplateid
        let inputPayload = {
          ratetemplateid: this.selectedEditRow.ratetemplateid
        }
        result =  MasterService.clientContractMasterRateDetails(payload);
        result2 =  MasterService.getClientContractMasterVehicleDeliveryRateList(inputPayload);
        result3 =  MasterService.getClientContractMasterOverWeightChargeList(inputPayload);
        responseArr = await Promise.all([result, result2, result3])

      }

      data = responseArr[0].data.data.rows[0];
      deliveryRate = responseArr[1].data.data;
      overWeightCharge = responseArr[2].data.data;

      let labelofA
      if(data.minimumchargetype==1){
        labelofA = "Base Rate x (Applicable Weight or Number of boxes)"
      }else{
        labelofA = "Net Charges"
      }

      this.minimumChargesData=[{
        type: "heading",
        key: "Minimum Charges Per Docket",
        value: [{
          type: "detail",
          key: "Minimum Charge Type",
          value: (data.minimumchargetype==1)?"On basic freight":"On net charges (before GST)"
        },{
          type: "detail",
          key: "A",
          value: labelofA
        },{
          type: "label",
          key: "B",
          value: (data.minimumcharges && ("Minimum docket amount (INR) : "+data.minimumcharges)) || "Minimum docket amount (INR) : "
        },{
          type: "detail",
          key: "Minimum Charges (INR)",
          value: "MAX(A,B)"
        }]
      }]

      this.accessorialChargesData = [{
        type: "heading",
        key: "Waybill Charges",
        value: [{
          type: "label",
          key: "Waybill Charges (INR)",
          value: data.waybillcharge && (data.waybillcharge + " Per Waybill")
        }]
      }]
      this.accessorialChargesData.push({
        type: "heading",
        key: "DC Charges",
        value: [{
          type: "label",
          key: "DC Charges (INR)",
          value: data.dccharges && (data.dccharges + " Per Waybill")
        }]
      })
      if (data.fodchargetype == 1) {
        this.accessorialChargesData.push({
          type: "heading",
          key: "FTC/ To Pay Charges",
          value: [{
            type: "label",
            key: "Per Docket",
            value: data.fodcharges && (data.fodcharges + "(INR)")
          }]
        })
      } else {
        this.accessorialChargesData.push({
          type: "heading",
          key: "FTC/ To Pay Charges",
          value: [{
            type: "detail",
            key: "% of freight charges",
            value:  data.fodcharges && (data.fodcharges + "(%)")
          }, {
            type: "label",
            key: "Limits (FOD Charges) (INR)",
            value: null
          },{
            type: "label",
            key: "Min",
            value: data.fodmincharge
          }, {
            type: "label",
            key: "Max",
            value: data.fodmaxcharge
          }]
        })
      }
      this.accessorialChargesData.push({
        type: "heading",
        key: "Fuel Surcharge",
        value: [{
          type: "detail",
          key: "Fuel Surcharge",
          value: data.fuelsurchargepercent && ("Freight Charges x " + data.fuelsurchargepercent + " (Surcharge %) /100")
        }]
      }, {
        type: "heading",
        key: "Diesel Price Hike",
        value: [
          {
            type: "label",
            key: "Diesel Rate (INR/Ltr) on agreement date: ",
            value: data.fueldieselrate
          },
          {
            type: "label",
            key: "Diesel Price Hike By (INR/%)",
            value: (data.dieselhiketype)?data.dieselhiketype:'%'
          },
          {
            type: "detail",
            key: "Location Basis for Reference Diesel Price",
            value: data.dieselreflocation
          },          
          {
            type: "detail",
            key: "Increase in Fuel Rate by",
            value: data.fueluprevision
          },
          {
            type: "label",
            key: "Increase in Base Rate by",
            value: data.fueluprevisioncharge
          },
          {
            type: "detail",
            key: "Decrease in Fuel Rate by",
            value: data.fueldownrevision
          },
          {
            type: "label",
            key: "Decrease in Base Rate by",
            value: data.fueldownrevisioncharge
          }
        ]
      }, {
        type: "heading",
        key: "Delivery Attempts",
        value: [{
          type: "label",
          key: "Free delivery attempts",
          value: data.deliveryattempt
        },
        {
         type: "detail",
         key: "Minimum cost per paid attempt per docket (INR)",
         value: data.deliveryattemptmincharge
       },
       {
          type: "detail",
          key: (data.deliveryattempttype == 1)?"Cost per paid attempt per kg (INR)":"Cost per paid attempt per box (INR)",
          value: data.costperdeliveryattempt
        }]
      })
      if(data.demurragechargesapplicable==1){
        let costtypelable = "";
        if(data.demurragecostperdaytype == 1){
          costtypelable = "Cost per kg per day (INR)";
        }else if(data.demurragecostperdaytype == 2){
          costtypelable = "Cost per box per day (INR)"
        }else if(data.demurragecostperdaytype == 3){
          costtypelable = "Cost per slot days (INR)";
        }

       this.accessorialChargesData.push({
        type: "heading",
        key: "Storage Charges",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.demurragechargesapplicable==1)?"Yes":"No"
        },{
          type: "label",
          key: "Free storage days",
          value: data.demurragefreestoragedays
        }, {
          type: "label",
          key: "Slot Days",
          value: data.demurrageslotsdays
        },{
          type: "label",
          key: costtypelable,
          value: data.demurragecostperday
        },{
          type: "detail",
          key: "Cost per Docket per Day (INR)",
          value: data.demurrageminimumcharges
        }]
      })
    }
    else{
      this.accessorialChargesData.push({
       type: "heading",
       key: "Demurrage Charges",
       value: [{
         type: "label",
         key: "Applicable",
         value: (data.demurragechargesapplicable==1)?"Yes":"No"
       }]
     })
    }
      let vehicledelchargetype
      if(data.vehicledeliverychargetype==1){
        vehicledelchargetype="Flat Rate"
      }else if(data.vehicledeliverychargetype==2){
        vehicledelchargetype="Slab Based"
      }else if(data.vehicledeliverychargetype==3){
        vehicledelchargetype="Approval Basis"
      }
      if(data.vehicledeliveryapplicable==1 && data.vehicledeliverychargetype==1 ){
        this.accessorialChargesData.push({
        type: "heading",
        key: "Appointment/Different Vehicle Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.vehicledeliveryapplicable==1)?"Yes":"No"
        },{
          type: "label",
          key: "Rate Basis",
          value: (data.vehicledeliveryratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
        },{
          type: "label",
          key: "Rate Type",
          value: vehicledelchargetype
        },{
          type: "label",
          key: "Cost per kg (INR)",
          value: deliveryRate[0] && deliveryRate[0].cost ? deliveryRate[0].cost : ''
        },{
          type: "label",
          key: "Minimum charge per docket (INR)",
          value: data.vehicledeliveryminimumchargeperdocket
        }]
      })
      }else if(data.vehicledeliveryapplicable==1 && data.vehicledeliverychargetype==2){
        this.accessorialChargesData.push({
        type: "heading",
        key: "Appointment/Different Vehicle Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.vehicledeliveryapplicable==1)?"Yes":"No"
        },{
          type: "label",
          key: "Rate Basis",
          value: (data.vehicledeliveryratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
        },{
          type: "label",
          key: "Rate Type",
          value: vehicledelchargetype
        },{
          type: "label",
          key: "Slab Type",
          value: (data.vehicledeliveryslabtype==1)?"Weight (kg)":"Quantity (Number of boxes)"
        },{
          type: "label",
          key: "Slab Charge Type",
          value: (data.vehicledeliveryslabchargetype==1)?"Incremental":"Absolute"
        },{
          type: "table",
          key: tableHeader,
          value: this.getTableData(deliveryRate)
        },{
          type: "label",
          key: "Minimum charge per docket (INR)",
          value: data.vehicledeliveryminimumchargeperdocket
        }]
      })
    }else if(data.vehicledeliveryapplicable==1 && data.vehicledeliverychargetype==3){
      this.accessorialChargesData.push({
      type: "heading",
      key: "Appointment/Different Vehicle Delivery",
      value: [{
        type: "label",
        key: "Applicable",
        value: (data.vehicledeliveryapplicable==1)?"Yes":"No"
      },{
        type: "label",
        key: "Rate Basis",
        value: (data.vehicledeliveryratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
      },{
        type: "label",
        key: "Rate Type",
        value: vehicledelchargetype
      },{
        type: "label",
        key: "Minimum charge per docket (INR)",
        value: data.vehicledeliveryminimumchargeperdocket
      }]
    })
    }else{
      this.accessorialChargesData.push({
      type: "heading",
      key: "Appointment/Different Vehicle Delivery",
      value: [{
        type: "label",
        key: "Applicable",
        value: (data.vehicledeliveryapplicable==1)?"Yes":"No"
      }]
    })
  }
       this.accessorialChargesData.push({
        type: "heading",
        key: "Mathadi/ Varai Charges",
        value: [{
          type: "label",
          key: "Flat rate per box (MPS) (INR)",
          value: data.mathadichargesperbox
        }]
      })
      if(data.handlingchargesapplicable==1){
       this.accessorialChargesData.push({
        type: "heading",
        key: "Handling Charges",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.handlingchargesapplicable==1)?"Yes":"No"
        },{
          type: "detail",
          key: "Max Limits for no handling charges",
          value: null
        }, {
          type: "label",
          key: "Physical weight (Kg)",
          value: data.handlingchargephysicalwt
        }, {
          type: "label",
          key: "Dimensions (cm)",
          value: data.handlingchargedimesnion &&  data.handlingchargedimesnion.handlinglength && data.handlingchargedimesnion.handlingbreadth && data.handlingchargedimesnion.handlingHeight &&  data.handlingchargedimesnion.handlinglength + "(L) " + data.handlingchargedimesnion.handlingbreadth + "(B) " + data.handlingchargedimesnion.handlingHeight + "(H)"
        }, {
          type: "detail",
          key: "Over Weight Charges",
          value: null
        }]
      })
      if (data.handlingchargeoverwtchargetype == 1) {
        this.accessorialChargesData[this.accessorialChargesData.length - 1].value.push({
          type: "label",
          key: "Charge Type",
          value: "Flat Rate"
        }, {
          type: "label",
          key: "Per Kg over max limit (INR)",
          value: overWeightCharge[0].cost
        })
      } else {
        this.accessorialChargesData[this.accessorialChargesData.length - 1].value.push({
          type: "label",
          key: "Charge Type",
          value: "Slab Rate"
        }, {
          type: "table",
          key: ["From", "To", "Cost per kg (INR) (Per overweight MPS)"],
          value: this.getTableDataForHandling(overWeightCharge)
        },{
          type: "label",
          key: "Mechanical handling charges (forklift/crane) on actuals for weight above (kg)",
          value: data.mechanicalhandlingcharges
        })
        }
      this.accessorialChargesData[this.accessorialChargesData.length - 1].value.push({
        type: "detail",
        key: "Over Dimension Charges",
        value: "Dedicated vehicle cost at agreed rates"
      })
    }
    else{
      this.accessorialChargesData.push({
       type: "heading",
       key: "Handling Charges",
       value: [{
         type: "label",
         key: "Applicable",
         value: (data.handlingchargesapplicable==1)?"Yes":"No"
       }]
     })
    }
    if(data.delievryabovegroundlevelapplicable==1){
      this.accessorialChargesData.push({
        type: "heading",
        key: "Delivery Above Ground Level",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.delievryabovegroundlevelapplicable==1)?"Yes":"No"
        },{
          type: "detail",
          key: "Max level above ground for no extra charge: ",
          value: (data.delievryabovegroundlevelmax == 0)?'Ground': data.delievryabovegroundlevelmax
        }, {
          type: "detail",
          key: "Extra charges for delivery above max level defined",
          value: null
        },{
          type: "label",
          key: "INR per kg per floor",
          value: data.delievryabovegroundlevelchargeperkg
        },{
          type: "label",
          key: "INR per box per floor",
          value: data.delievryabovegroundlevelchargeperdocket
        }]
      });
    }else{
        this.accessorialChargesData.push({
          type: "heading",
          key: "Delivery Above Ground Level",
          value: [{
            type: "label",
            key: "Applicable",
            value: (data.delievryabovegroundlevelapplicable==1)?"Yes":"No"
          }]
        })
      }
    this.accessorialChargesData.push({
        type: "heading",
        key: "Green Tax (For Delhi Inbound shipments only)",
        value: [
          {
            type: "label",
            key: "Cost per kg (INR)",
            value: data.greentaxperkg
          },
          {
            type: "label",
            key: "Cost per docket (INR)",
            value: data.greentaxperdocket
          },
      ]
      }, {
        type: "heading",
        key: "RTO Charges",
        value: [
          {
            type: "detail",
            key: "INR per rate basis (kg/box) in addition to contract rates applicable for destination",
            value: data.rtocharges
          }
        ]
      })

      await this.getDataForODAMatrix(id);
      let odaTempArray = [];
      if(data.pickupodachargesapplicable==1){
        if(data.pickupodachargetype==1){
          odaTempArray.push({
            type: "detail",
            key: "Applicable for Pickup",
            value: (data.pickupodachargesapplicable==1)?"Yes":"No"
          },{
            type: "label",
            key: "Rate Basis",
            value: (data.pickupodachargeratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Rate Type",
            value: (data.pickupodachargetype==1)?"Flat Rate":"Slab Rate"
          },{
            type: "label",
            key: "Minimum cost per docket",
            value: data.pickupodachargesminimum,
          },{
            type: "detail",
            key: "ODA 1 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.pickupodatable1[0])?this.pickupodatable1[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.pickupodatable1[0])?this.pickupodatable1[0]["Charges Per Docket"]:""
          }, {
            type: "detail",
            key: "ODA 2 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.pickupodatable2[0])?this.pickupodatable2[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.pickupodatable2[0])?this.pickupodatable2[0]["Charges Per Docket"]:""
          },{
            type: "detail",
            key: "ODA 3 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.pickupodatable3[0])?this.pickupodatable3[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.pickupodatable3[0])?this.pickupodatable3[0]["Charges Per Docket"]:""
          },{
            type: "detail",
            key: "Special Pin code charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.pickupodatable4[0])?this.pickupodatable4[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.pickupodatable4[0])?this.pickupodatable4[0]["Charges Per Docket"]:""
          });
        }
        if(data.pickupodachargetype==2){
          odaTempArray.push({
            type: "detail",
            key: "Applicable for Pickup",
            value: (data.pickupodachargesapplicable==1)?"Yes":"No"
          },{
            type: "label",
            key: "Rate Basis",
            value: (data.pickupodachargeratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Rate Type",
            value: (data.pickupodachargetype==1)?"Flat Rate":"Slab Rate"
          },{
            type: "label",
            key: "Slab Type",
            value: (data.pickupodachargeslabtype==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Slab Charge Type",
            value: (data.pickupodachargeslabchargetype==1)?"Incremental":"Absolute"
          },{
            type: "detail",
            key: "ODA 1 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.pickupodatable1
          },{
            type: "label",
            key: "ODA 2 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.pickupodatable2
          },{
            type: "label",
            key: "ODA 3 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.pickupodatable3
          },{
            type: "label",
            key: "Special Pin Code Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.pickupodatable4
          },{
            type: "label",
            key: "Minimum cost per docket",
            value: data.pickupodachargesminimum,
          });
        }
      }else{
        odaTempArray.push({
          type: "detail",
          key: "Applicable for Pickup",
          value: (data.pickupodachargesapplicable==1)?"Yes":"No"
        });
      }
      if(data.odachargesapplicable==1){
        if(data.odachargetype==1){
          odaTempArray.push({
            type: "detail",
            key: "Applicable for Delivery",
            value: (data.odachargesapplicable==1)?"Yes":"No"
          },{
            type: "label",
            key: "Rate Basis",
            value: (data.odachargeratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Rate Type",
            value: (data.odachargetype==1)?"Flat Rate":"Slab Rate"
          },{
            type: "label",
            key: "Minimum cost per docket",
            value: data.odachargesminimum,
          },{
            type: "detail",
            key: "ODA 1 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.odatable1[0])?this.odatable1[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.odatable1[0])?this.odatable1[0]["Charges Per Docket"]:""
          }, {
            type: "detail",
            key: "ODA 2 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.odatable2[0])?this.odatable2[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.odatable2[0])?this.odatable2[0]["Charges Per Docket"]:""
          },{
            type: "detail",
            key: "ODA 3 Charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.odatable3[0])?this.odatable3[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.odatable3[0])?this.odatable3[0]["Charges Per Docket"]:""
          },{
            type: "detail",
            key: "Special Pin code charges",
            value: null
          }, {
            type: "label",
            key: "Additional rate per kg (INR)",
            value: (this.odatable4[0])?this.odatable4[0]["Rate Per Basis"]:""
          },{
            type: "label",
            key: "Additional rate per docket (INR)",
            value: (this.odatable4[0])?this.odatable4[0]["Charges Per Docket"]:""
          });
        }
        if(data.odachargetype==2){
          odaTempArray.push({
            type: "detail",
            key: "Applicable for Delivery",
            value: (data.odachargesapplicable==1)?"Yes":"No"
          },{
            type: "label",
            key: "Rate Basis",
            value: (data.odachargeratebasis==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Rate Type",
            value: (data.odachargetype==1)?"Flat Rate":"Slab Rate"
          },{
            type: "label",
            key: "Slab Type",
            value: (data.odachargeslabtype==1)?"Weight (kg)":"Quantity (Number of boxes)"
          },{
            type: "label",
            key: "Slab Charge Type",
            value: (data.odachargeslabchargetype==1)?"Incremental":"Absolute"
          },{
            type: "detail",
            key: "ODA 1 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.odatable1
          }, {
            type: "label",
            key: "ODA 2 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.odatable2
          },{
            type: "label",
            key: "ODA 3 Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.odatable3
          },{
            type: "label",
            key: "Special Pin Code Charges",
            value: null
          }, {
            type: "table",
            key: odaTableHeader,
            value: this.odatable4
          },{
            type: "label",
            key: "Minimum cost per docket",
            value: data.odachargesminimum,
          });
        }
      }else{
        odaTempArray.push({
          type: "detail",
          key: "Applicable for Delivery",
          value: (data.odachargesapplicable==1)?"Yes":"No"
        });
      }
      let odaTemplateObj = {
        type: "heading",
        key: "ODA Charges",
        value: odaTempArray
      };
      this.accessorialChargesData.push(odaTemplateObj);

    if(data.openpickdeliveryapplicable==1){
      this.accessorialChargesData.push({
        type: "heading",
        key: "Open Pickup/Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.openpickdeliveryapplicable==1)?"Yes":"No"
        },{
          type: "label",
          key: "Rate per box per docket (INR)",
          value: data.openpickdeliverycharges
        },{
          type: "label",
          key: "Rate per Item within Child Shipment (INR)",
          value: data.openpickdeliveryrateperitem
        },{
          type: "label",
          key: "Minimum cost per docket",
          value: data.openpickdeliverychargesminimum
        }]
      })
    }
    else{
      this.accessorialChargesData.push({
        type: "heading",
        key: "Open Pickup/Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: (data.openpickdeliveryapplicable==1)?"Yes":"No"
        }]
      })
    }
    if(data.holidaydeliverychargeapplicable == 1){
      this.accessorialChargesData.push({
        type: "heading",
        key: "Holiday Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: "Yes"
        },{
          type: "label",
          key: (data.holidaydeliverychargestype == 1)?"Rate per kg per docket (INR)":"Rate per box per docket (INR)",
          value: data.holidaydeliverycharges
        },{
          type: "label",
          key: "Minimum cost per docket (INR)",
          value: data.holidaydeliverymincharges
        }]
      })
    }else {
      this.accessorialChargesData.push({
        type: "heading",
        key: "Holiday Delivery",
        value: [{
          type: "label",
          key: "Applicable",
          value: "No"
        }]
      })
    }
      this.isLoading = false;
    },

    getTableData(data) {
      let tableData = []
        data.map(obj => {
          tableData.push({
            "From": obj.fromvalue,
            "To": obj.tovalue,
            "Cost per Docket": obj.cost
          })
        })
      return tableData
    },
    getTableDataForHandling(data) {
      let tableData = []
        data.map(obj => {
          tableData.push({
            "From": obj.fromvalue,
            "To": obj.tovalue,
            "Cost per Docket": obj.cost
          })
        })
      return tableData
    },
    getTableDataForHandling(data) {
      let tableData = []
      data.map(obj => {
        tableData.push({
          "From": obj.fromvalue,
          "To": obj.tovalue,
          "Cost per kg (INR) (Per overweight MPS)": obj.cost
        })
      })
      return tableData
    },

    async getDataForODAMatrix(id) {
      try {
        let payload = {}
        let odaTemplateDetails
        if (this.selectedEditRow.ComponentName == CONSTANT.RATE_TEMPLATE) {
          payload.ratetemplateid = id
          odaTemplateDetails = await MasterService.getOdaChargeListRateTemplate(payload);
        } else if (this.selectedEditRow.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
          payload.ratetemplateid = this.selectedEditRow.ratetemplateid
          odaTemplateDetails = await MasterService.getContractMasterOdaChargeList(payload);
        } else if (this.selectedEditRow.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          payload.ratetemplateid = this.selectedEditRow.ratetemplateid
          odaTemplateDetails = await MasterService.getClientContractMasterOdaChargeList(payload);
        }
        let splitArrayODAType = this.groupBy(odaTemplateDetails.data.data, "odatype");
        if(splitArrayODAType && splitArrayODAType.Delivery){
          let splitArray = this.groupBy(splitArrayODAType.Delivery, "templatesequence")
          let index = 1;
          if (splitArray['1']) {
            this.odatable1 = []
            splitArray['1'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.odatable1.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['2']) {
            this.odatable2 = []
            splitArray['2'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.odatable2.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['3']) {
            this.odatable3 = []
            splitArray['3'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.odatable3.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['4']) {
            this.odatable4 = []
            splitArray['4'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.odatable4.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
        }
        if(splitArrayODAType && splitArrayODAType.Pickup){
          let splitArray = this.groupBy(splitArrayODAType.Pickup, "templatesequence")
          let index = 1;
          if (splitArray['1']) {
            this.pickupodatable1 = []
            splitArray['1'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.pickupodatable1.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['2']) {
            this.pickupodatable2 = []
            splitArray['2'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.pickupodatable2.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['3']) {
            this.pickupodatable3 = []
            splitArray['3'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.pickupodatable3.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
          if (splitArray['4']) {
            this.pickupodatable4 = []
            splitArray['4'].forEach(obj => {
              let name = `${this.SYMBOL_CONFIG[obj.lowerlimit]} ${obj.lowerlimitvalue} to
                    ${this.SYMBOL_CONFIG[obj.higherlimit]} ${obj.higherlimitvalue}`
              this.pickupodatable4.push({
                "Slab Break": name,
                "Rate Per Basis": obj.charges,
                "Charges Per Docket": obj.chargesperdocket
              })
            })
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },

    getWithoutDecimalValue(str) {
      let convertedChargeValue = str.toString().split(".");
      convertedChargeValue = convertedChargeValue[1] == "00" ? convertedChargeValue[0] : el.charges;
      return convertedChargeValue
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/ratetemplateview/Ratetemplateview.component.js